import { ref } from 'vue';

export type PdsTheme = 'light' | 'dark';

const STORAGE_KEY = 'pds.theme';

const readStoredTheme = (): PdsTheme => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
};

const theme = ref<PdsTheme>(readStoredTheme());

const apply = (value: PdsTheme) => {
  document.documentElement.dataset.theme = value;
};

export const initTheme = () => apply(theme.value);

export const useTheme = () => {
  const setTheme = (value: PdsTheme) => {
    theme.value = value;
    apply(value);
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch {
      // Sans stockage, le thème vaut pour la session seulement.
    }
  };

  return { theme, setTheme };
};
